import React from 'react';
import {
  List,
  SingleFieldList,
  Datagrid,
  CardActions,
  CreateButton,
  FunctionField,
  DateField,
  ReferenceManyField,
  SelectInput,
  TextField,
  TextInput,
  ShowButton,
  Filter,
  SelectField,
} from 'react-admin';
import { getAdminLevel, ADMIN_LEVELS } from '../../authProvider';
import { adminLevelLabels } from '../../helpers/mappings';
import CustomExportButton from '../CustomExportButton';
import { modelFields, transformDataForExportFn } from './constants';

const Filters = props => (
  <Filter {...props}>
    <TextInput label="Name | Email" source="_OMNI_" alwaysOn />
    <TextInput label="Account Number" source="accountNumber" alwaysOn />
    <TextInput label="First Name" source="_LIKE_firstName" />
    <TextInput label="Last Name" source="_LIKE_lastName" />
    <TextInput label="Email" source="_LIKE_email" />
    <SelectInput
      source="role"
      label="Role"
      choices={[
        { id: '_null_', name: 'No Role' },
        ...adminLevelLabels.filter(entry => entry.id),
      ]}
    />
    <SelectInput
      label="Is Approved"
      source="approvedAt"
      choices={[
        { id: '_not_null_', name: 'Yes' },
        { id: '_null_', name: 'No' },
      ]}
    />
  </Filter>
);

const Actions = ({
  basePath,
  displayedFilters,
  filters,
  filterValues,
  resource,
  showFilter,
  currentSort,
  total,
}) => {
  const adminLevel = getAdminLevel();
  const isFullAdmin = adminLevel && adminLevel === ADMIN_LEVELS.FULL_ADMIN;
  return (
    <CardActions>
      {filters && React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      }) }
      {isFullAdmin && <CreateButton basePath={basePath} />}
      {isFullAdmin &&
      <CustomExportButton
        filter={filterValues}
        sort={currentSort}
        total={total}
        resource={resource}
        exportTitle="External Offer Orders - Export"
        modelFields={modelFields}
        transformFn={transformDataForExportFn}
      />}
    </CardActions>
  );
};

export default props => (
  <List
    {...props}
    title="Users"
    bulkActionButtons={false}
    sort={{ field: 'email', order: 'asc' }}
    filters={<Filters />}
    actions={<Actions />}
  >
    <Datagrid>
      <TextField label="Email" source="email" />
      <TextField label="First Name" source="firstName" />
      <TextField label="Last Name" source="lastName" />
      <SelectField label="Role" source="role" choices={adminLevelLabels} />
      <DateField label="Created At" source="createdAt" />
      <DateField label="Sign Up Completed At" source="signUpCompletedAt" />
      <DateField label="Approved At" source="approvedAt" />
      <ReferenceManyField label="Accounts" reference="accounts" target="userId" source="id">
        <SingleFieldList linkType={false}>
          <TextField source="accountNumber" />
        </SingleFieldList>
      </ReferenceManyField>
      <ReferenceManyField label="Restricted" reference="accounts" target="userId" source="id">
        <SingleFieldList linkType={false}>
          <FunctionField render={record => `${record.accountRestrictions.length > 0 ? 'Yes' : 'No'}`} />
        </SingleFieldList>
      </ReferenceManyField>
      <TextField label="Status" source="status" />
      <ShowButton />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/components/User/List.jsx